import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-dot",
  "use": "default-dot-usage",
  "viewBox": "0 0 28.9 28.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.9 28.9\" id=\"default-dot\"><circle cx=\"14.5\" cy=\"14.5\" r=\"12\" stroke-width=\"5\" stroke-miterlimit=\"10\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol